import { AxiosError } from "axios";

const getErrorMessage = (error: string | AxiosError | null): string | null => {
  if (!error) return null;
  if (typeof error === "string") return error;

  const axiosError = error as AxiosError;
  const responseMessage = (axiosError.response?.data as any)?.message;
  return responseMessage || axiosError.message;
};

export default getErrorMessage;